import { buildService } from './decorated-service';
import settings from '../../../settings.json';

export const mockedContriPeriodData = {
  iraContributionPeriodCutoffDate: '11-30-2022',
  priorYear: '2021',
  currentYear: '2022',
  withinPriorYearContributionPeriod: true
};

const contributionPeriod = buildService(
  '/nasu-svc/service/contribution-period'
);

export const getContributionPeriod = async (
  state: string | undefined
): Promise<any> => {
  if (settings['mockedMode']) return mockedContriPeriodData;
  return contributionPeriod.view(state);
};
